import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { SearchStatus } from '../constants';
import { tourAvailabilityRequest } from '../store/slices/tour';
import getTourQuoteKey from '../helpers/getTourQuoteKey';

const useTourQuote = (productId, details, { date, slot, rateQuantities }) => {
  const dispatch = useDispatch();
  const currencyCode = useSelector((store) => store.tripSearch.currencyCode);
  const availability = details?.availability;
  const slotDescription = availability?.requiresSlotDescription ? slot?.description : undefined;

  const requestQuote = (forDate, forSlot, forQuantities) => {
    if (!forDate || !Object.keys(forQuantities || {}).length) {
      return;
    }
    dispatch(
      tourAvailabilityRequest({
        productId,
        date: dayjs(forDate).format('YYYY-MM-DD'),
        rangeDays: 0,
        rateQuantities: forQuantities,
        slotDescription: availability?.requiresSlotDescription ? forSlot?.description : undefined,
      }),
    );
  };

  const isCurrent =
    !!details?.quoteKey &&
    details.quoteKey ===
      getTourQuoteKey({
        date: date && dayjs(date).format('YYYY-MM-DD'),
        rangeDays: 0,
        slotDescription,
        rateQuantities,
        currency: currencyCode || undefined,
      });
  // A current quote with no day is an answer too: the operator has no price for this date and party.
  const isQuoted = isCurrent && !!details?.quote;
  const quotedDay = isCurrent ? details?.quote?.days?.[0] : undefined;
  const quotedSlot = quotedDay?.slots?.find(
    (entry) => entry.time === slot?.time && entry.description === slot?.description,
  );

  return {
    isQuoted,
    quotedDay,
    quotedSlot,
    isQuoting: details?.quoteStatus === SearchStatus.SEARCHING,
    error: details?.quoteError,
    requestQuote,
  };
};

export default useTourQuote;
